import React, { useState } from 'react'

import { Separator } from 'shared/components'
import { useWindowSize } from 'shared/hooks'
import {
  CatalogFilters,
  CatalogList,
  CatalogSearch,
  CatalogSlider,
} from './common'
import { PartnersForm } from 'components/Partners'

import classes from './Catalog.module.scss'

export const Catalog = (): JSX.Element => {
  const { isLargeDesktop, isDesktop } = useWindowSize()
  const [isMore, setIsMore] = useState(false)

  return (
    <>
      <CatalogSlider />

      <Separator className={classes.separator} />

      <div className="container">
        <h1 className={`${classes.title} title"`}>
          ОРИГИНАЛЬНЫЕ ФИЛЬМЫ{'\n'}И СЕРИАЛЫ
          <span> KION</span>
        </h1>

        <CatalogSearch setIsMore={setIsMore} />

        <div className={`${classes.catalog_row} row visible align-start`}>
          {(isLargeDesktop || isDesktop) && (
            <div className={`${classes.filters} col-xs-12 col-sm-3`}>
              <CatalogFilters setIsMore={setIsMore} />
            </div>
          )}
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9">
            <CatalogList isMore={isMore} setIsMore={setIsMore} />
          </div>
        </div>
      </div>

      <Separator height={60} />

      <div className="container">
        <PartnersForm />
      </div>

      <Separator height={60} />
    </>
  )
}
